var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9949 2.82373C12.9037 1.24892 11.5977 0 10 0H3L2.82373 0.00509269C1.24892 0.0963391 0 1.40232 0 3V15L0.00509269 15.1763C0.0963391 16.7511 1.40232 18 3 18H10L10.1763 17.9949C11.7511 17.9037 13 16.5977 13 15V13L12.9933 12.8834C12.9355 12.386 12.5128 12 12 12C11.4477 12 11 12.4477 11 13V15L10.9933 15.1166C10.9355 15.614 10.5128 16 10 16H3L2.88338 15.9933C2.38604 15.9355 2 15.5128 2 15V3L2.00673 2.88338C2.06449 2.38604 2.48716 2 3 2H10L10.1166 2.00673C10.614 2.06449 11 2.48716 11 3V5L11.0067 5.11662C11.0645 5.61396 11.4872 6 12 6C12.5523 6 13 5.55228 13 5V3L12.9949 2.82373ZM16.7071 5.29289L16.6129 5.2097L16.5114 5.14038C16.1275 4.91161 15.6233 4.96245 15.2929 5.29289L15.2097 5.3871C14.9047 5.77939 14.9324 6.34662 15.2929 6.70711L16.585 8H5L4.88338 8.00673C4.38604 8.06449 4 8.48716 4 9C4 9.55229 4.44772 10 5 10H16.584L15.2929 11.2929L15.2097 11.3871C14.9047 11.7794 14.9324 12.3466 15.2929 12.7071C15.6834 13.0976 16.3166 13.0976 16.7071 12.7071L19.6663 9.74886C19.7702 9.65522 19.8527 9.54075 19.9101 9.41512L19.9506 9.31113L19.9871 9.16511C20.0387 8.86782 19.9589 8.54465 19.7071 8.29289L16.7071 5.29289Z",
    fill: "#121419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogout);
export default __webpack_public_path__ + "static/media/menu-logout.99afe04bcaf813a5f67e7ca0848ca4ad.svg";
export { ForwardRef as ReactComponent };